import {expectOneOf, HttpClient, POST, PUT, ServerValidationResult} from '@raison/network-facade';
import {AccountId} from '@raison/types';
import BigNumber from 'bignumber.js';
import {CryptoCurrencyType} from '~/entities/currencies';
import {TransactionHolderSchema} from '~/entities/operations-crypto';
import {TwoFaProviderKind} from '~/features/two-factor';
import {SendOpUsualValues} from '../ui/SendUsualTx';

interface SendOpUsualFormData extends SendOpUsualValues {
    feeAmount: BigNumber;
    amount: BigNumber;
    repeated: boolean;
    provider: TwoFaProviderKind;
    address: string;
    comment: string;
}

export async function submitSendTxForm(
    http: HttpClient,
    accountId: AccountId,
    accountType: CryptoCurrencyType,
    data: SendOpUsualFormData
) {
    const body = {
        to: data.address,
        fee: data.feeAmount,
        amount: data.amount.toString(),
        comment: data.comment,
        beneficiary: data.beneficiaryName,
        beneficiary_country: data.beneficiaryCountry,
        repeated_event: data.repeated,
        two_fa_provider: data.provider.kind,
        ...(data.provider.kind === 'sms'
            ? {
                  verificationMethod: data.provider.method,
                  device_id: window.appDeviceId,
                  app_version: window.appVersion,
              }
            : null),
    };

    const {url, method} = (() => {
        switch (accountType) {
            case 'crypto':
                return {url: `v1/wallets/${accountId}/send`, method: PUT};
            case 'stablecoin':
                return {url: `v1/tokens/${accountId}/send/prepare`, method: POST};
        }
    })();

    return await http(url, method(body)).then(
        expectOneOf({
            200: TransactionHolderSchema,
            201: TransactionHolderSchema,
            401: null,
            400: SendTxIssues,
        })
    );
}

export type SendTxIssues = ({} & (typeof SendTxIssues)['~standard']['types'])['output'];
const SendTxIssues = ServerValidationResult.to({
    'to?': 'string',
    'amount?': 'string',
    'comment?': 'string',
    'fee?': 'string',
    'beneficiary?': 'string',
    'beneficiary_country?': 'string',
}).pipe(d => ({
    address: d.to,
    comment: d.comment,
    amount: d.amount,
    feeCalculationType: d.fee,
    beneficiaryName: d.beneficiary,
    beneficiaryCountry: d.beneficiary_country,
}));
